module.exports = __webpack_public_path__ + "resources/img/img_watchall_lms2_m_en.a441ea2fff44f00a7ebad1240cd5f350.png";